import { db } from '@/firebase.js'
import { functions } from '@/assets/script/functions.js'
import searchHelper from '@/helpers/searchHelper'

const recipes = {
  state: {
    recipeUrl: '',
    AllRecipes: [],
    Favorites: [],
    Done: [],
    AdminSearchQuery: ''
  },
  mutations: {
    setRecipeUrl(state, url) {
      state.recipeUrl = url
    },
    setRecipesData(state, recipes) {
      state.AllRecipes = recipes
    },
    setDone(state, list) {
      state.Done = list
    },
    setFavorites(state, list) {
      state.Favorites = list
    },
    setAdminSearchQuery(state, query) {
      state.AdminSearchQuery = query
    }
  },
  actions: {
    async initRecipes({ dispatch }) {
      await dispatch('getRecipeData')
      dispatch('getFavorites')
      dispatch('getDone')
    },
    // Gets all recipes from firebase
    async getRecipeData({ commit }) {
      const collectionData = await db.collection('RecipeData').get()
      const recipeData = collectionData.docs.map(doc => doc.data())
      commit('setRecipesData', recipeData)
    },
    // Derive favorites from the recipe.Favorite field on AllRecipes - the
    // admin editor writes the boolean there, so it's the source of truth.
    getFavorites({ commit, state }) {
      const favorites = state.AllRecipes.filter(r => r.Favorite).map(r => r.Id.toString())
      commit('setFavorites', favorites)
    },
    getDone({ commit, state }) {
      const done = state.AllRecipes.filter(r => r.Done).map(r => r.Id.toString())
      commit('setDone', done)
    },
    async saveRecipe({ commit, dispatch, state }, recipe) {
      const docId = recipe.Id.toString();
      const isNew = !state.AllRecipes.find(r => r.Id.toString() === docId);

      await db.collection('RecipeData').doc(docId).set(recipe);

      let newAllRecipes = [...state.AllRecipes];
      if (isNew) {
        newAllRecipes.push(recipe);
      } else {
        const index = newAllRecipes.findIndex(r => r.Id.toString() === docId);
        if (index !== -1) newAllRecipes.splice(index, 1, recipe);
      }
      commit('setRecipesData', newAllRecipes);
      dispatch('getFavorites');
      dispatch('getDone');
    },
    async deleteRecipe({ commit, dispatch, state }, id) {
      const docId = id.toString();
      await db.collection('RecipeData').doc(docId).delete();
      commit('setRecipesData', state.AllRecipes.filter(r => r.Id.toString() !== docId));
      dispatch('getFavorites');
      dispatch('getDone');
    }
  },
  getters: {
    allRecipes: (state) => functions.getUnique(state.AllRecipes, 'Title'),
    getRecipeById: state => url => state.AllRecipes.find(recipe => recipe.Url == url),
    getThisRecipe: state => state.AllRecipes.find(recipe => recipe.Url == state.recipeUrl),
    getXSimilarRecipes: (state, getters) => x => {
      let categories = getters.getThisRecipe.Categories.map(category => category.Name)
      let searchResult = searchHelper.search(categories, getters.allRecipes)
      while (searchResult.length < x) {
        categories.pop()
        searchResult = searchHelper.search(categories, getters.allRecipes)
      }
      return searchResult.filter(result => result.Id != getters.getThisRecipe.Id).splice(0, x)
    },
    getRecipeDoneById: state => id => state.Done.includes(id.toString()),
    getRecipeFavoriteById: state => id => state.Favorites.includes(id.toString()),
    getFavorites: state => state.Favorites,
    getDone: state => state.Done,
    adminSearchQuery: state => state.AdminSearchQuery
  }
}
export default recipes